import { fetcher } from '@commenda/utils';
import { IIndirectTaxUpdateRegistrationV2Response } from './types';

export async function archiveIndirectTaxRegistration(
  registrationId: string,
  corporationId: number
): Promise<{
  success: boolean;
  data?: IIndirectTaxUpdateRegistrationV2Response;
  error?: string;
}> {
  try {
    const query = new URLSearchParams();
    query.append('corporationId', corporationId?.toString());

    const response = await fetcher(
      `new-sales-tax/registrations-v2/${registrationId}/archive?${query}`,
      { method: 'POST' },
      undefined
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to archive registration',
      };
    }

    const data: IIndirectTaxUpdateRegistrationV2Response = await response.json();
    return { success: true, data };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to archive registration';
    return { success: false, error: errorMessage };
  }
}
